import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

const CommentSkeleton = () => {
  return (
    <>
      <Box sx={{ padding: "10px" }}>
        <Skeleton
          animation="wave"
          variant="rectangular"
          sx={{ width: "30%", height: "40px", marginBottom: "10px" }}
        />
        <Skeleton
          animation="wave"
          variant="rectangular"
          sx={{ width: "100%", height: "60px" }}
        />
        {Array.from({ length: 10 }).map((ele, index) => (
          <Box key={index} sx={{ padding: "5px 0" }}>
            <Box
              sx={{
                display: "flex",
                gap: "6px",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <Skeleton
                animation="wave"
                variant="circular"
                width={48}
                height={48}
              />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  flexDirection: "column",
                  gap: "1px",
                  flexGrow: "1",
                }}
              >
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{ width: "20%", height: "8px", marginBottom: "10px" }}
                />
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{ width: "60%", height: "10px", marginBottom: "10px" }}
                />
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  sx={{ width: "10%", height: "10px", marginBottom: "10px" }}
                />
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default CommentSkeleton;
